var map = {
	"./alcohol_en.png": 73,
	"./carbs_en.png": 684,
	"./cardio_en.png": 453,
	"./fatburn_en.png": 825,
	"./floors_en.png": 876,
	"./fruit_en.png": 96,
	"./mood_en.png": 913,
	"./peak_en.png": 575,
	"./red_meat_en.png": 64,
	"./restful_activities_en.png": 851,
	"./salt_en.png": 896,
	"./saturated_fat_en.png": 885,
	"./sleep_hygiene_en.png": 182,
	"./speed_en.png": 122,
	"./standing_en.png": 745,
	"./steps_en.png": 658,
	"./stress_en.png": 445,
	"./vegetable_en.png": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 516;